<template>
  <v-row justify="center"
    v-if="showPrivacyPolicy"
  >
    <v-layout wrap>
      <v-flex xs12>
        <table>
          <tr>
            <td style="padding-left: 10px;">
              <v-checkbox
                v-model="checkPrivacy"
                hidedetails
              />
            </td>
            <td style="margin-top: -2px;">
              <span @click="checkPrivacy = !checkPricacy" class="v-label theme--light" style="color: rgba(0, 0, 0, 0.54);">
                {{ $t('settings.formTerms.agree', locale)}}
              </span>
              <span @click="dialog=true" class="v-label theme--light" style="cursor:pointer;">
                {{ $t('settings.formTerms.privacyPolicy', locale).toLowerCase()}} (*)
              </span>
            </td>
          </tr>
        </table>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="privacy-policy">
        <v-toolbar
          dark
          :color="BGColor"
          elevation="0"
        >
          <v-btn
            icon
            :color="Color"
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title :style="{ color: Color }">
            {{ $t('settings.formTerms.privacyPolicy', locale) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              text
              :color="Color"
              @click="handleAgree"
            >
              {{ $t('settings.formTerms.agree', locale)}}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <vue-editor 
          class="main-terms"
          v-model="privacyPolicy"
          :disabled="true"
          :editor-toolbar="customToolbar"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
const minToolbar = [[],[],[],[],[],[],[],[],[],[],[],[],[{  }],[]]
import { mapState } from 'vuex'
import { VueEditor } from 'vue2-editor'
import constants from '@/constants'
import utilsService from '@/services/utils'
import api from '@/services/api'
export default {
  components: {
    VueEditor,
  },
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    onLoadChangePrivacyPolicy: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    showPrivacyPolicy: false,
    privacyPolicy: null,
    checkPrivacy: false,
  }),
  computed: {
    ...mapState('app',['FontContent', 'FontSizeContent', 'ColorContent', 'BGColor', 'Color']),
    customToolbar () {
      return minToolbar
    },
  },
  watch: {
    workspaceID () {
      this.handleGetData()
    },
    locale () {
      this.handleGetData()
    },
    checkPrivacy () {
      this.onLoadChangePrivacyPolicy (this.showPrivacyPolicy, this.checkPrivacy)
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleGetData () {
      this.showPrivacyPolicy = false
      this.privacyPolicy = null


      if (!this.workspaceID) {
        this.onLoadChangePrivacyPolicy (this.showPrivacyPolicy, this.checkPrivacy)
        return
      }

      api.getAll(`enterprises/terms/${this.workspaceID}`, false, 1, 100000, '')
        .then(response => {
          if (!response || response.length === 0) {
            this.onLoadChangePrivacyPolicy (this.showPrivacyPolicy, this.checkPrivacy)
            return
          }
          const aux = response.shift()
          this.showPrivacyPolicy = aux && aux.ShowPrivacyPolicy ? true : false
          this.onLoadChangePrivacyPolicy (this.showPrivacyPolicy, this.checkPrivacy)
          this.privacyPolicy = aux && aux.PrivacyPolicy ? utilsService.getTranslation(JSON.parse(aux.PrivacyPolicy), this.locale) : null 
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    handleAgree () {
      this.checkPrivacy = true
      this.dialog = false
    },
  },
}
</script>
<style>
.privacy-policy .ql-container.ql-snow {
  border: 0 !important;
}
</style>
